/**
 * Types
 */
type Props = {
  text: string
}
type TextObjectType = 'url' | 'text' | 'empty' | 'newLine'
type TextObject = {
  type: TextObjectType
  value: string
}
type UseTextWithUrlToLink = () => {
  textToTextObjects: (props: Props) => TextObject[]
}

/**
 * Constants
 */
const NEW_LINE_REGEX = /(\r\n|\n|\r)/g
const URL_REGEX = /(https?:\/\/[^\s<>"'\x80-\uFFFF]+)/g // 末端チェック（<, >, 2バイト文字などを除外）

/**
 * 正規表現で文字列を分割する
 */
const splitByRegex = (
  text: string,
  regex: RegExp,
  type: TextObjectType,
): TextObject[] =>
  text.split(regex).map<TextObject>((part) => {
    if (part.match(regex)) {
      return {
        type,
        value: part,
      }
    }
    else if (part === '') {
      return {
        type: 'empty',
        value: part,
      }
    }
    else {
      return {
        type: 'text',
        value: part,
      }
    }
  })

/**
 * Composable
 */
export const useTextWithUrlToLink: UseTextWithUrlToLink = () => {
  return {
    textToTextObjects: ({ text }) =>
      splitByRegex(text, NEW_LINE_REGEX, 'newLine').flatMap((textObject) => {
        if (textObject.type === 'newLine') {
          return textObject
        }
        return splitByRegex(textObject.value, URL_REGEX, 'url')
      }),
  }
}

/**
 * Functions
 */
export const simpleLinkifyText = (text: string | undefined | null) => {
  return (text || '').replace(URL_REGEX, (url) => {
    const punctuationMatch = url.match(/([.,!?]+)$/) // URLの末尾が句読点かチェック
    const cleanUrl = punctuationMatch
      ? url.slice(0, -punctuationMatch[0].length)
      : url
    const trailingPunctuation = punctuationMatch
      ? punctuationMatch[0]
      : ''
    return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>${trailingPunctuation}`
  })
}
